import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { logger } from "@/lib/logger";

const Forbidden = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    logger.info("403 Error: User attempted to access a restricted route", {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{t("errors.forbiddenCode")}</h1>
        <p className="mb-4 text-xl text-muted-foreground">
          {t("errors.accessDenied")}
        </p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          {t("errors.returnHome")}
        </a>
      </div>
    </div>
  );
};

export default Forbidden;
